import type { PropsWithChildren } from 'react';

import { VStack, cn } from '@/package';

import ContainerContent from './ContainerContent';
import ContainerHeader from './ContainerHeader';
import ContainerOverview from './ContainerOverview';

const Container = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div className="w-full min-w-[calc(var(--container-md)-var(--spacing-sidebar))]">
      <VStack className={cn('h-full items-start @xl:items-center', className)}>
        {children}
      </VStack>
    </div>
  );
};

Container.Content = ContainerContent;
Container.Header = ContainerHeader;
Container.Overview = ContainerOverview;

export default Container;
